export function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

export function isTryOnMobile() {
  return window.innerWidth < 1000;
}

export function isDesktopViewport() {
  return window.matchMedia('(min-width: 1000px)').matches;
}

export { loadScriptAsync, loadScriptOnIntent } from './intent-loader';